import React, { useState, useEffect } from 'react';
import { APP_CONFIG } from '../../utils/constants';
import GroupSelector from '../Common/GroupSelector';
import { useAuth } from '../../contexts/AuthContext';
import { usersAPI } from '../../services/api';

const Header = ({ onToggleSidebar, onLogout, sidebarOpen }) => {
  const { user, isSuperAdmin } = useAuth();
  const [userInfo, setUserInfo] = useState({ name: '', email: '', role: '' });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await usersAPI.me();
        if (response.data?.data) {
          setUserInfo({
            name: response.data.data.name || response.data.data.email || 'User',
            email: response.data.data.email || '',
            role: response.data.data.role || (isSuperAdmin ? 'Superadmin' : 'User')
          });
        }
      } catch (err) {
        // Fallback to token info if API fails
        if (user) {
          setUserInfo({
            name: user.email || 'User',
            email: user.email || '',
            role: user.role || (isSuperAdmin ? 'Superadmin' : 'User')
          });
        }
      }
    };
    fetchUserInfo();
  }, [user, isSuperAdmin]);

  const displayName = userInfo.name || userInfo.email || 'User';
  const displayRole = userInfo.role || (isSuperAdmin ? 'Superadmin' : 'User');

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {onToggleSidebar && !sidebarOpen && (
            <button
              type="button"
              className="header-sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
            <i class="fa-solid fa-bars"></i>
            </button>
          )}
          {/* <img 
            src={`${process.env.PUBLIC_URL || ''}/logo-icon.png`}
            alt="Logo" 
            className="header-logo-icon"
            style={{
              width: '40px',
              height: '40px',
              objectFit: 'contain',
              display: 'block',
              visibility: 'visible'
            }}
            onError={(e) => {
              // Show console error for debugging
              console.error('Logo icon failed to load. Path:', e.target.src);
              console.error('Make sure logo-icon.png exists in Frontend/public/ folder');
              // Show a placeholder instead of hiding
              e.target.style.display = 'none';
            }}
            onLoad={() => {
              console.log('Logo icon loaded successfully');
            }}
          /> */}
        </div>
        <nav className="header-nav" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <GroupSelector />
          <div className="header-user-info" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button className="header-icon-btn" title="Notifications" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' }}>
              <i class="fa-regular fa-bell" style={{ fontSize: '20px', color: '#0F2854' }}></i> 
            </button>
            <button className="header-icon-btn" title="Dark Mode" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' }}>
              <i class="fa-regular fa-moon" style={{ fontSize: '20px', color: '#0F2854' }}></i>
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '8px' }}>
              <i
                className="fa-solid fa-circle-user"
                style={{ fontSize: '24px' }}
              ></i>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span className="nav-text" style={{ fontSize: '0.875rem', fontWeight: 600, textTransform: 'uppercase', color: '#0F2854' }}>{displayName}</span>
                <span style={{ fontSize: '0.75rem', color: '#6B7280' }}>{displayRole}</span>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
